import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import { FolderType } from '@models';

@NgModule()
export class TriggersMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TriggersMetaModule,
            providers: [
                providePageMeta({
                    title: 'Triggers',
                    translationKey: 'page_triggers',
                    routerLink: '/triggers',
                    sidebarSection: 'Automations',
                    svgIcon: 'uipath:triggers',
                    permission: 'Schedules.View',
                    category: PageCategory.Tenant,
                    type: 'Sidebar',
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                    priority: 1,
                }),
                providePageMeta({
                    title: 'Triggers Add',
                    translationKey: 'page_triggers_add',
                    routerLink: '/triggers/add',
                    permission: 'Schedules.Create',
                    type: 'Breadcrumb',
                    category: PageCategory.Tenant,
                    parentRoute: '/triggers',
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                }),
                providePageMeta({
                    title: 'Triggers Edit',
                    translationKey: 'page_triggers_edit',
                    routerLink: '/triggers/:id/edit',
                    permission: 'Schedules.Edit',
                    type: 'Breadcrumb',
                    category: PageCategory.Tenant,
                    parentRoute: '/triggers',
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                }),
            ],
        };
    }
}
